import type { ReactNode } from 'react';
import type { Tone } from './StatusBadge';

interface MetricCardProps {
  label: string;
  value: string;
  hint?: string;
  tone?: Tone;
  /** `hero` is for the two or three figures that carry the story. */
  size?: 'hero' | 'default';
  footnote?: ReactNode;
}

export function MetricCard({ label, value, hint, tone = 'neutral', size = 'default', footnote }: MetricCardProps) {
  return (
    <div className={`metric metric--${size} metric--${tone}`}>
      <span className="metric__label">{label}</span>
      <span className="metric__value">{value}</span>
      {hint ? <span className="metric__hint">{hint}</span> : null}
      {footnote ? <div className="metric__footnote">{footnote}</div> : null}
    </div>
  );
}
